import React from 'react'
import PropTypes from 'prop-types'
import Link from 'components/Link'
import ProductControls from 'components/ProductControls'
import ProductPrices from 'components/ProductPrices'
import ImageLoad from 'components/ImageLoad'
import Average from 'components/Reviews/Average'
import ProductFlags from 'components/ProductFlags'
import FavoriteButton from 'components/FavoriteButton'
import { features } from 'config'
import notImage from 'images/foto_en_preparacion.png'
import useShelfProductHook from 'hooks/useShelfProduct';
import { withRouter } from "react-router-dom";
import AddToListButton from 'components/ShelfProduct/AddToListButton'
import style from './style.scss' //NOSONAR

const ShelfProductV2 = (props) => {
    const shelfProduct = useShelfProductHook(props);

    const {
        unitMeasurement,
        exclusiveJumbo,
        productName,
        skuData,
        productImage,
        link,
        openDrawer,
        callbackLoading,
        productClick,
        producRedirect,
        gtmWithoutStock,
        openModalAddToList,
        product,
        callback,
        callbackAddToCart,
        qtyInit,
        isLogged,
        stock,
        item,
        controlsConfig,
        addToList,
        gtmData,
        goToBrand
    } = shelfProduct

    return (
        <div className="shelf-product-island-v2">
            <div className="shelf-product-buttons-wrap-v2">
                <FavoriteButton sku={item.itemId} position={props.position} type={'tooltip_favorite_plp'} />
                <AddToListButton openModalAddToList={openModalAddToList} itemId={item.itemId} productId={product.Id}/>
            </div>
            <div className="shelf-product-image-section" onClick={() => producRedirect()}>
                <Link
                    to={link}
                    onClick={productClick}
                    className={
                        'shelf-wrap-image-v2 ' +
                        (!isLogged ? ' not-logged ' : '') +
                        (!stock && features.personalize ? ' image-out-of-stock' : '')
                    }
                    aria-label={productName}>
                    {productImage && (
                        <ImageLoad
                            src={productImage}
                            errorImage={notImage}
                            alt={productName}
                            gtmData={gtmData}
                            callback={gtmWithoutStock}
                        />
                    )}
                    {!productImage && (
                        <ImageLoad
                            src={notImage}
                            errorImage={notImage}
                            alt={productName}
                            gtmData={gtmData}
                            callback={gtmWithoutStock}
                        />
                    )}
                </Link>
            </div>
            <div className="shelf-product-info-section">
                <div className="shelf-info-product">
                    {item && <ProductFlags item={item} nutritionalTag={true} stock={stock} exclusiveJumbo={exclusiveJumbo} />}
                    <a onClick={() => goToBrand(props?.product?.brand)} title={props?.product?.brand} className="shelf-product-brand">
                        <h2 className="shelf-product-brand">{props?.product?.brand}</h2>
                    </a>
                    <Link to={link} onClick={productClick} title={productName} className="shelf-product-title">
                        <h2 className='shelf-product-title-text'>{productName}</h2>
                    </Link>
                    {!!item.unitMultiplier && <span className="shelf-single-unit">{unitMeasurement}</span>}
                </div>
                {!!qtyInit && <span className="shelf-product-init">Solicitado {qtyInit} un</span>}
                {!!stock && <ProductPrices item={item} skuData={skuData} onlyCurrentPrice={true} productDetail={false} />}
            </div>
            <div className="shelf-product-control-section">
                {!!stock && (
                    <div className="shelf-product-bottom-btns">
                        <ProductControls
                            item={item}
                            id={item.itemId}
                            config={controlsConfig}
                            quantity={item.quantity}
                            inCart={item.inCart}
                            qtyInit={qtyInit}
                            callback={callback}
                            callbackLoading={callbackLoading}
                            callbackAddToCart={callbackAddToCart}
                            exclusiveJumbo={exclusiveJumbo}
                            addToList={addToList}
                            recommendedByCategory={props.recommendedByCategory}
                        />
                    </div>
                )}
                {props.product && props.product.productId && <Average comment={false} single={true} productId={props.product.productId}/>}
                {!stock && (
                    <div className="no-stock">
                        {!features.personalize ? (
                            <>
                                <i className="font-icn alert" />
                                <span className="no-stock-text">Sin Stock</span>
                            </>
                        ) : (
                            <button className="secundary-btn" onClick={openDrawer}>
                                Ver similares
                            </button>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

ShelfProductV2.propTypes = {
    product: PropTypes.object,
    small: PropTypes.bool,
    listTitle: PropTypes.string,
    position: PropTypes.number,
    item: PropTypes.object,
    limitTitle: PropTypes.number,
    callback: PropTypes.func,
    qtyInit: PropTypes.string,
    notPDP: PropTypes.bool,
    gtmData: PropTypes.object,
    favorites: PropTypes.array,
    callbackAddToCart: PropTypes.func,
    addToList: PropTypes.object,
    recommendedByCategory: PropTypes.bool
}

export default withRouter(ShelfProductV2)
